import { eventBus } from '../app';
import axios from '../config/axios';

export default {
    delimiters: ['${', '}'],
    template: '#modal-book-viewing-template',
    props: [
        'name', 'email', 'siteId', 'siteName'
    ],
    data() {
        return {
            show: false,
            product: {},
            stockists: [],
            messageSent: false,
            formState: {
                name: '',
                email: '',
                phone: '',
                subject: '',
                message: '',
                postCode: '',
                countryCode: 'GB',
                stockistId: null,
                stockist: '',
                newsletter: false,
                consent: false,
                siteName: 'Roper Rhodes',
                perSiteRecipient: 0,
                includeProject: null,
				CRAFT_CSRF_TOKEN: null
            }
        };
    },
    created() {
        document.addEventListener('keyup', (event) => {
            if (event.keyCode == 27) {
                this.toggleModal();
            }
        });

        eventBus.$on('book-viewing', this.openModal);
    },
    mounted() {
        this.bookViewingForm = document.getElementById('bookViewingForm');
    },
    beforeDestroy() {
        eventBus.$off('book-viewing', this.openModal);
    },
    computed: {
        stockist() {
            if(this.formState.stockistId) {
                const selectedStockist = this.stockists.filter(stockist => stockist.id === this.formState.stockistId)[0] ?? null;

                if(selectedStockist) {
                    return `${selectedStockist.title} | ${selectedStockist.id} | ${selectedStockist.accountNumber}`;
                }
            }

            return '';
        }
    },
    methods: {
        close() {
            this.show = false;

            // Reset form values to default
            this.stockists = [];
            this.postCode = '';
            this.countryCode = 'GB';
        },
        toggleModal() {
            this.show = !this.show;
        },
        openModal(event) {
            this.product = event.item.base;
            this.formState.subject = (this.product && this.product.name) ? this.product.name : '';

            if (this.product) {
                this.formState.message = "Hello,\n\nI'm interested in finding out more about this product or making an appointment at your showroom.\n\nThank you.";
            }
            else {
                this.formState.message = "Hello,\n\nI'm interested in making an appointment at your showroom.\n\nThank you.";
            }

            this.formState.email = this.email;
            this.formState.name = this.name;
            this.formState.siteName = this.siteName;
            this.formState.postCode = event.postcode;
            this.formState.perSiteRecipient = this.siteId - 1;
            this.formState.includeProject = event.project;
            this.messageSent = false;
            this.show = true;

			this.formState.CRAFT_CSRF_TOKEN = this.bookViewingForm.querySelector('[name="CRAFT_CSRF_TOKEN"]').value;

            if(event.stockist) {
                this.stockists.push(event.stockist);
                this.formState.stockistId = event.stockist.id;
                this.formState.stockistId = event.stockist.id;
            }
        },
        async findStockists() {
            // We need a post code and a country code to do a search
            if (!(this.formState.postCode && this.formState.countryCode)) {
                // Show validation messages if we can
                if (this.bookViewingForm.reportValidity) {
                    this.bookViewingForm.reportValidity();
                }
                return;
            }

            const formData = {
                postcode: this.formState.postCode,
                countrycode: this.formState.countryCode,
				CRAFT_CSRF_TOKEN: this.formState.CRAFT_CSRF_TOKEN,
            };

            const response = await axios.post('/actions/nearest-stockist/search/by-postcode', formData);

            if (response.data.success) {
                this.stockists = [...response.data.stockists];
                console.log(this.stockists);
                if (this.stockists.length > 0) {
                    this.selectedStockistId = null;
                    this.$nextTick(() => {
                        if (this.$refs.stockistSelect) {
                            this.$refs.stockistSelect.focus();
                        } else {
                            this.bookViewingForm.getElementById('bookingViewing_stockist').focus();
                        }
                    });
                }
            }
        },
        submitForm() {
            if (!this.bookViewingForm.reportValidity()) {
                return false;
            }

            // Clone data
            let data = JSON.parse(JSON.stringify(this.formState));

            axios.post('/actions/nearest-stockist/booking/book', data)
            .then(() => {
                this.messageSent = true;
                this.bookViewingForm.submit();
            });
        }
    }
};

